import { useId } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

interface Props {
    checked?: boolean;
    label: string;
    propertyName: string;
    onFieldChange: (prop: string, value: boolean) => void;
}

const Checkbox = (props:Props) => {
    const id = useId();
    const checkboxId = `bcd-checkbox-${id}`;

    return (
        <div className="mt-3 mb-3">
            <FormGroup check>
                <Input
                    type="checkbox"
                    id={checkboxId}
                    name={props.propertyName}
                    checked={props.checked}
                    onChange={(e) => props.onFieldChange(e.target.name, e.target.checked)}/>
                <Label className="form-check-label" htmlFor={checkboxId}>
                    {props.label}
                </Label>
            </FormGroup>
        </div>
    );
}

export default Checkbox;